import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { VesselOwnershipEvents } from 'icreate/common/io-event/websocket-message';
import { BehaviorSubject } from 'rxjs';
import { VesselOwnershipTransfer } from 'icreate/common/models/vessel-ownership-transfer';

@Injectable({
    providedIn: 'root',
})
export class VesselOwnershipSocketService {
    private ownershipTransfersSubject = new BehaviorSubject<VesselOwnershipTransfer[]>([]);
    readonly ownershipTransfers$ = this.ownershipTransfersSubject.asObservable();

    constructor(private socketService: SocketMiddlewareService) {
        this.socketService
            .receiveMessageObserver(VesselOwnershipEvents.OWNERSHIP_REQUESTED)
            .subscribe((t: VesselOwnershipTransfer) => this.upsertOwnershipTransfer(t));

        this.socketService
            .receiveMessageObserver(VesselOwnershipEvents.OWNERSHIP_CLAIMED)
            .subscribe((t: VesselOwnershipTransfer) => this.upsertOwnershipTransfer(t));

        this.socketService
            .receiveMessageObserver(VesselOwnershipEvents.OWNERSHIP_REJECTED)
            .subscribe((t: VesselOwnershipTransfer) => this.upsertOwnershipTransfer(t));

        this.socketService
            .receiveMessageObserver(VesselOwnershipEvents.OWNERSHIP_ASSIGNED)
            .subscribe((t: VesselOwnershipTransfer) => this.upsertOwnershipTransfer(t));

        this.socketService
            .receiveMessageObserver(VesselOwnershipEvents.OWNER_LEFT)
            .subscribe((t: VesselOwnershipTransfer) => this.upsertOwnershipTransfer(t));

        this.socketService
            .receiveMessageObserver(VesselOwnershipEvents.OWNER_REMOVED)
            .subscribe((t: VesselOwnershipTransfer) => this.upsertOwnershipTransfer(t));
    }

    ownershipRequested$() {
        return this.socketService.receiveMessageObserver(VesselOwnershipEvents.OWNERSHIP_REQUESTED);
    }

    ownershipClaimed$() {
        return this.socketService.receiveMessageObserver(VesselOwnershipEvents.OWNERSHIP_CLAIMED);
    }

    ownershipRejected$() {
        return this.socketService.receiveMessageObserver(VesselOwnershipEvents.OWNERSHIP_REJECTED);
    }

    ownershipAssigned$() {
        return this.socketService.receiveMessageObserver(VesselOwnershipEvents.OWNERSHIP_ASSIGNED);
    }

    ownerLeft$() {
        return this.socketService.receiveMessageObserver(VesselOwnershipEvents.OWNER_LEFT);
    }

    ownerRemoved$() {
        return this.socketService.receiveMessageObserver(VesselOwnershipEvents.OWNER_REMOVED);
    }

    upsertOwnershipTransfer(transfer: VesselOwnershipTransfer) {
        const current = this.ownershipTransfersSubject.value;

        const idx = current.findIndex(x => x.id === transfer.id);

        let updated: VesselOwnershipTransfer[];

        if (idx !== -1) {
            updated = [...current.slice(0, idx), transfer, ...current.slice(idx + 1)];
        } else {
            updated = [...current, transfer];
        }

        this.ownershipTransfersSubject.next(updated);
    }
}
